(function () {
  function drawerEl() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openDrawer() {
    if (window.OdditCartDrawer) window.OdditCartDrawer.open();
  }

  // The drawer is server-rendered with no client-side model, so a refresh means
  // re-fetching the section. Only the innards are swapped: the root element keeps
  // its `is-open` class and the open/close listeners bound to it.
  //
  // The id comes off the element rather than being hardcoded: this section lives in
  // a section group, so its real id is `sections--<theme_id>__oddit_cart_drawer`,
  // not the bare key from header-group.json. Passing the bare key 404s.
  function refresh() {
    var current = drawerEl();
    if (!current || !current.id) return Promise.reject(new Error('Cart drawer not on page'));

    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(current.id), {
      cache: 'no-store'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Section render failed (' + r.status + ') for ' + current.id);
        return r.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-cart-drawer]');
        if (!fresh) throw new Error('No [data-cart-drawer] in rendered section');
        current.innerHTML = fresh.innerHTML;
        return fetch('/cart.js', { cache: 'no-store' }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        // oddit-section-header.js listens for this to repaint the count badges.
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function showError(form, message) {
    var slot = form.querySelector('.product-form__error-message');
    if (!slot) return;
    slot.textContent = message;
    slot.closest('.product-form__error-message-wrapper').hidden = false;
  }

  // Every product form on the page routes through here — main product, sticky
  // add-to-cart (which submits the main form), quick adds.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    setLoading(button, true);

    var body = new FormData(form);

    // The subscription app injects its own hidden selling_plan (plus subs_* fields)
    // into this form and overwrites what the purchase-option toggle sets. Our toggle
    // is the source of truth, so strip the app's plan when one-time is selected.
    var activeOption = document.querySelector(
      '.oddit-section-main-product__purchase-option--active'
    );
    if (activeOption && activeOption.dataset.purchaseType === 'one-time') {
      body.delete('selling_plan');
      body.delete('subs_interval');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        return refresh().then(openDrawer);
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        showError(form, err.message);
      })
      .finally(function () {
        setLoading(button, false);
      });
  });

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed (' + r.status + ')');
        return r.json();
      })
      .then(refresh);
  }

  // One in-flight cart mutation at a time: the drawer re-renders from the server
  // after each one, so a second click would be reading a stale quantity.
  var busy = false;

  function mutate(promiseFn) {
    if (busy) return;
    busy = true;
    promiseFn()
      .catch(function (err) {
        console.error('Cart update failed', err);
      })
      .finally(function () {
        busy = false;
      });
  }

  // Line quantity — the drawer renders quantity as text, not an input.
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-quantity-change]');
    if (!step) return;

    var line = step.closest('[data-line-item]');
    var value = line ? line.querySelector('[data-quantity-input]') : null;
    if (!value) return;

    var next = parseInt(value.textContent, 10) + parseInt(step.dataset.quantityChange, 10);
    if (isNaN(next) || next < 0) return;

    mutate(function () {
      return changeLine(step.dataset.lineItemKey, next);
    });
  });

  // Remove — quantity 0 is how the Cart API deletes a line.
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-remove-item]');
    if (!remove) return;

    mutate(function () {
      return changeLine(remove.dataset.lineItemKey, 0);
    });
  });

  // Subscription upsell — converts every eligible cart line onto its selling plan.
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-upsell-cta]');
    if (!cta) return;

    var pairs = (cta.dataset.upsellPlans || '')
      .split(',')
      .filter(Boolean)
      .map(function (pair) {
        return pair.split(':');
      });
    if (!pairs.length) return;

    cta.disabled = true;
    // ponytail: sequential, because a line index is only valid against the cart
    // the previous call returned — Shopify merges lines that become identical.
    // Switch to a single /cart/update.js if line drift ever bites.
    pairs
      .reduce(function (chain, pair) {
        return chain.then(function () {
          var line = parseInt(pair[0], 10);

          
          return fetch('/cart.js', { cache: 'no-store' })
            .then(function (r) {
              if (!r.ok) throw new Error('Could not read cart (' + r.status + ')');
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) return null;

              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  line: line,
                  quantity: item.quantity,
                  selling_plan: parseInt(pair[1], 10)
                })
              }).then(function (r) {
                if (!r.ok) throw new Error('Plan change failed on line ' + line + ' (' + r.status + ')');
                return r.json();
              });
            });
        });
      }, Promise.resolve())
      .then(refresh)
      .catch(function (err) {
        console.error('Subscription upgrade failed', err);
      })
      .finally(function () {
        cta.disabled = false;
      });
  });

  window.OdditCart = { refresh: refresh, open: openDrawer };
})();
